export default "__VITE_ASSET__b2840ad6__"